<template>
  <VerificationForm />
</template>
<script setup>
import { useTitle } from "@vueuse/core";
import VerificationForm from "@/components/forms/VerificationForm.vue";

useTitle("Banxa - Verify your email");
</script>
